import { ScreenHeader } from '@/components/layout/screen-header';
import React from 'react';
import { Pressable, Text } from 'react-native';

interface NotificationsHeaderProps {
  unreadCount: number;
  onMarkAllAsRead?: () => void;
}

export function NotificationsHeader({
  unreadCount,
  onMarkAllAsRead,
}: NotificationsHeaderProps) {
  const subtitle =
    unreadCount > 0
      ? `You have ${unreadCount} unread notification${unreadCount > 1 ? 's' : ''}`
      : undefined;

  const rightSlot =
    unreadCount > 0 ? (
      <Pressable onPress={onMarkAllAsRead}>
        <Text className="font-medium text-primary">
          Mark all as read
        </Text>
      </Pressable>
    ) : undefined;

  return (
    <ScreenHeader
      title="Notifications"
      subtitle={subtitle}
      rightSlot={rightSlot}
      showMenuButton
    />
  );
}
